import { Attrs, EventListeners, MinzeElement, Reactive } from "minze";

export class TjCheckbox extends MinzeElement {
  reactive: Reactive = [["checked", false, true]];

  attrs: Attrs = ["name", "label", ["default-value", ""]];
  id: string = Math.random().toString(36).substr(2, 9);

  static observedAttributes = ["placeholder", "type", "name", "default-value"];

  async onReady() : Promise<void> {
    const defVal = this.defaultValue as boolean;
    this.checked = defVal ?? false;
    this.rerender();
  };

  html() {
    return `
      <tj-box display="flex" alignItems="flex-start">
        <input
          type="checkbox"
          id="${this.id}"
          name="${this.name}"
          ${this.checked ? `checked` : ""}
          class="checkbox"
        />
        <label for="${this.id}">
          ${this.label}
        </label>
      </tj-box>
    `;
  }

  css = () => `
    :host {
      width: 100%;
    }

    .checkbox:checked::after {
      content: '✓';
      color: #1E007D;
      display: block;
      width: 100%;
      height: 100%;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .checkbox {
      margin: 5px 0 0;
      border-radius: 6px;
      text-align: center;
      appearance: none;
      border: 1px solid #AAAAAA;
      height: 24px;
      min-height: 24px;
      max-height: 24px;
      width: 24px;
      min-width: 24px;
      max-width: 24px;
      display: block;
      position: relative;
      font-size: 16px;
      line-height: 1px;
      background: transparent;
      color: transparent;
    }

    label {
      margin-left: 8px;
      color: #133762;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }
  `;

  handleInput(event: Event) {
    this.checked = (event as any)?.target?.checked;
    this.rerender();
  };

  eventListeners: EventListeners = [
    ["input", "change", this.handleInput.bind(this)],
  ];
}
